import { Component } from '@angular/core';
import { ErrorCodeComponent } from './error-code.component';

@Component({
    selector: 'app-error-404',
    template: `
      <app-error-code
        code="404"
        title="Page not found!"
        message="This is not the web page you are looking for."
      />
    `,
  imports: [ErrorCodeComponent],
})
export class Error404Component {}
